import {axios, createAsyncThunk} from '../thunk-config'

export default createAsyncThunk('cart/updateInCartUpsellPrice', async ({campaign_id, offer_id, order_offer_quantity, discount_code, order_offer_item_options, headers}, {rejectWithValue}) => {
  try {
    const response = await axios.post('/utilv2/offer_price', {
      campaign_id, offer_id, order_offer_quantity, discount_code, order_offer_item_options
    }, {headers})

    if(response.data.data) {
      return response.data.data
    } else {
      return rejectWithValue({message: 'Internal server error', data: response.data})
    }
  } catch(err) {
    if(!err.response) {
      throw err
    }

    return rejectWithValue(err.response.data)
  }
})


// WEBPACK FOOTER //
// ./client/resources/js/checkout/redux/thunks/updateInCartUpsellsPrice.js